import { actionTypes, routesNames } from '@/core/constants'
import store from '@/core/store'
import router from '@/views/routers'

class ValidarPermissaoUsuarioListener {
	async execute() {
		const dominio = store.state.loki.user.domainType
		const autorizacoes = store.state.loki.user.authorities

		if (this.ehPerfilEstruturaOrganizacional(dominio)) {
			if (autorizacoes.length === 0) {
				await store.dispatch(actionTypes.COMUM.ATUALIZAR_SESSAO, 0)
				await router.push({ name: routesNames.ATA.ATA_VIEW })
			}
		}
	}

	ehPerfilEstruturaOrganizacional(dominio) {
		return dominio === 'ESTRUTURA_ORGANIZACIONAL'
	}
}

export default new ValidarPermissaoUsuarioListener()
